'use client';
'use strict';

var react = require('react');
var reactDom = require('react-dom');

const DEFAULT_PORTAL_ID = 'wds-portal-root';
const Portal = ({ children, rootId, needCleanup = true })=>{
    const [portalElement, setPortalElement] = react.useState(null);
    const portalId = rootId || DEFAULT_PORTAL_ID;
    react.useEffect(()=>{
        let element = document.getElementById(portalId);
        if (!element) {
            element = document.createElement('div');
            element.id = portalId;
            document.body.appendChild(element);
        }
        element.setAttribute('data-testid', portalId);
        setPortalElement(element);
        return ()=>{
            needCleanup && element && !element.childNodes.length && element.remove();
        };
    }, [
        portalId,
        rootId,
        needCleanup
    ]);
    if (!portalElement) return null;
    return reactDom.createPortal(children, portalElement);
};

module.exports = Portal;
